import { render, staticRenderFns } from "./TemporaryStorage.vue?vue&type=template&id=61bc37d2&scoped=true"
import script from "./TemporaryStorage.vue?vue&type=script&lang=js"
export * from "./TemporaryStorage.vue?vue&type=script&lang=js"
import style0 from "./TemporaryStorage.vue?vue&type=style&index=0&id=61bc37d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc37d2",
  null
  
)

export default component.exports